const unsafeFilenameChars = /[<>:"/\\|?*\u0000-\u001f]/g;
const reservedWindowsNames = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;

function sanitizeFilenameBase(value: string) {
  const name = value
    .normalize("NFC")
    .replace(unsafeFilenameChars, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[. ]+$/g, "");

  if (!name) return "resume";
  if (reservedWindowsNames.test(name)) return `${name} resume`;

  return name;
}

function sanitizeExtension(value: string) {
  return value.replace(/^\.+/, "").replace(unsafeFilenameChars, "").trim();
}

export function generateFilename(prefix: string, extension?: string) {
  const name = sanitizeFilenameBase(prefix);
  const ext = extension ? sanitizeExtension(extension) : "";

  return `${name}${ext ? `.${ext}` : ""}`;
}

export function downloadWithAnchor(blob: Blob, filename: string) {
  const a = document.createElement("a");
  const url = URL.createObjectURL(blob);

  a.href = url;
  a.rel = "noopener";
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function downloadFromUrl(url: string, filename: string) {
  const response = await fetch(url);
  const blob = await response.blob();

  downloadWithAnchor(blob, filename);
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(",")[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
